export const DELIVERY_BUCKETS: { label: string; test: RegExp }[] = [
  { label: "Sofort verfügbar", test: /sofort|lagernd|24.?h/i },
  { label: "1–3 Tage", test: /1.?-?.?3\s*Tag/i },
  { label: "4–7 Tage", test: /[45].?-?.?7\s*Tag/i },
  { label: "1–2 Wochen", test: /1.?-?.?2\s*Woch|7.?-?.?14/i },
  { label: "2–4 Wochen", test: /2.?-?.?4\s*Woch|14.?-?.?28/i },
  { label: "4+ Wochen", test: /[4-9]\+?\s*Woch|\d{2,}\s*Tag/i },
];

export function bucketDeliveryTime(
  raw: string | null | undefined,
): string | null {
  if (!raw) return null;
  const t = raw.trim();
  if (!t) return null;
  for (const bucket of DELIVERY_BUCKETS) {
    if (bucket.test.test(t)) return bucket.label;
  }
  // Fallback: raw string (kein Datenverlust)
  return t;
}
